/* Angel Fire Apparel — editable cinematic cue engine */
(function () {
  'use strict';
  var context = null;
  var active = [];
  var patterns = {
    opening: [[220,0,1.4,'sine',.09],[330,.38,1.55,'sine',.08],[440,.78,1.8,'triangle',.08],[660,1.18,1.7,'sine',.05],[880,1.55,1.4,'triangle',.025]],
    prologue: [[196,0,1.8,'sine',.09],[294,.35,1.9,'sine',.075],[392,.72,2.2,'triangle',.08],[523,1.02,1.8,'sine',.05],[784,1.35,1.6,'sine',.04]],
    solaris: [[58,0,2.2,'sawtooth',.06],[82,.14,1.9,'sawtooth',.055],[110,.28,1.7,'sawtooth',.06],[146,.44,1.35,'square',.035],[220,.76,.75,'triangle',.11],[440,1.04,.38,'square',.045]],
    lunar: [[196,0,1.5,'sine',.04],[392,.18,1.5,'sine',.065],[587,.48,1.5,'sine',.06],[784,.86,1.9,'sine',.05],[1174,1.22,1.4,'triangle',.035],[1568,1.52,.8,'sine',.02]],
    argent: [[330,0,.72,'triangle',.085],[494,.24,1,'sine',.065],[659,.55,1.3,'triangle',.065],[988,.88,1,'sine',.04],[1318,1.25,.6,'triangle',.025]],
    aetherial: [[220,0,1.3,'sine',.05],[330,.22,1.35,'sine',.05],[440,.46,1.5,'sine',.07],[660,.78,1.75,'sine',.06],[880,1.05,1.7,'triangle',.05],[1320,1.42,1,'sine',.025]],
    void: [[45,0,2.5,'sine',.105],[55,.34,2.3,'sine',.085],[73,.72,2,'sine',.07],[110,1.1,1.8,'triangle',.045]],
    entry: [[180,0,.3,'sawtooth',.055],[260,.14,.35,'sawtooth',.05],[390,.25,.3,'square',.03],[520,.36,1.05,'sine',.085],[1040,.62,.75,'triangle',.045]],
    fragment: [[260,0,.45,'triangle',.055],[330,.18,.55,'sine',.04],[390,.28,.8,'sine',.06],[520,.5,.75,'triangle',.045]],
    reveal: [[660,0,.3,'triangle',.07],[880,.1,.6,'sine',.055],[1320,.27,1,'sine',.05],[1760,.55,.85,'triangle',.035],[2093,.82,.55,'sine',.02]],
    custom: [[120,0,.22,'square',.055],[220,.12,.28,'square',.045],[330,.23,.3,'triangle',.04],[440,.34,.85,'triangle',.08],[880,.6,.6,'sine',.045]],
    cart: [[180,0,.2,'square',.06],[330,.12,.22,'square',.045],[495,.2,.25,'triangle',.035],[660,.3,.8,'sine',.085],[990,.56,.6,'triangle',.04]],
    armory: [[82,0,.36,'square',.06],[120,.16,.35,'square',.045],[180,.31,.35,'square',.035],[220,.42,1.15,'sine',.085],[440,.76,.7,'triangle',.04]],
    checkout: [[330,0,.55,'sine',.08],[494,.26,1,'sine',.07],[659,.58,1.4,'triangle',.065],[988,.9,.9,'sine',.035],[1318,1.28,.5,'triangle',.02]],
    order: [[392,0,.56,'sine',.075],[494,.25,.62,'sine',.075],[659,.5,1.25,'triangle',.07],[988,.8,1.2,'sine',.045],[1318,1.2,.75,'triangle',.025]]
  };
  function applySavedEdits() {
    try {
      var saved = JSON.parse(localStorage.getItem('angel_fire_audio_edits') || 'null');
      if (!saved) return;
      Object.keys(saved).forEach(function (id) {
        if (!patterns[id] || !saved[id]) return;
        patterns[id][0][0] = Number(saved[id][0]) || patterns[id][0][0];
        patterns[id][0][2] = Number(saved[id][1]) || patterns[id][0][2];
        patterns[id][0][4] = Number(saved[id][2]) || patterns[id][0][4];
      });
    } catch (e) {}
  }
  function getContext() {
    if (!context) {
      var AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return null;
      context = new AudioContext();
    }
    if (context.state === 'suspended') context.resume();
    return context;
  }
  function tone(freq, when, duration, type, gain, pan) {
    var c = getContext(); if (!c) return;
    var osc = c.createOscillator(), amp = c.createGain(), out = c.createStereoPanner ? c.createStereoPanner() : null;
    osc.type = type; osc.frequency.setValueAtTime(freq, when);
    amp.gain.setValueAtTime(.0001, when);
    amp.gain.exponentialRampToValueAtTime(gain, when + .035);
    amp.gain.exponentialRampToValueAtTime(.0001, when + duration);
    if (out) { out.pan.setValueAtTime(pan || 0, when); osc.connect(amp).connect(out).connect(c.destination); }
    else osc.connect(amp).connect(c.destination);
    osc.start(when); osc.stop(when + duration + .18); active.push(osc);
  }
  function sweep(from, to, when, duration, gain, pan) {
    var c = getContext(); if (!c) return;
    var osc = c.createOscillator(), amp = c.createGain(), out = c.createStereoPanner ? c.createStereoPanner() : null;
    osc.type = 'sine'; osc.frequency.setValueAtTime(from, when); osc.frequency.exponentialRampToValueAtTime(to, when + duration);
    amp.gain.setValueAtTime(.0001, when); amp.gain.exponentialRampToValueAtTime(gain, when + .08); amp.gain.exponentialRampToValueAtTime(.0001, when + duration);
    if (out) { out.pan.setValueAtTime(pan || 0, when); osc.connect(amp).connect(out).connect(c.destination); }
    else osc.connect(amp).connect(c.destination);
    osc.start(when); osc.stop(when + duration + .18); active.push(osc);
  }
  function texture(when, duration, amount, cutoff) {
    var c = getContext(); if (!c) return;
    var n = c.createBufferSource(), b = c.createBuffer(1, c.sampleRate * duration, c.sampleRate), d = b.getChannelData(0);
    for (var i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * .7;
    n.buffer = b; var f = c.createBiquadFilter(), a = c.createGain(); f.type = 'lowpass'; f.frequency.value = cutoff;
    a.gain.setValueAtTime(amount, when); a.gain.exponentialRampToValueAtTime(.0001, when + duration);
    n.connect(f).connect(a).connect(c.destination); n.start(when); active.push(n);
  }
  function sparkle(when, count) { for (var i = 0; i < count; i++) tone(900 + i * 190, when + i * .095, .22, 'sine', .028, i % 2 ? -.75 : .75); }
  function pulse(when, count, base) { for (var i = 0; i < count; i++) tone(base, when + i * .22, .12, 'square', .025, i % 2 ? -.45 : .45); }
  function flare(when, id) {
    var low = id === 'solaris' || id === 'void';
    tone(low ? 52 : 110, when, .95, 'sine', low ? .055 : .03, -.4);
    tone(low ? 69 : 165, when + .16, .9, 'triangle', low ? .045 : .025, .4);
    sweep(low ? 70 : 180, low ? 28 : 880, when + .08, 1.3, .025, 0);
    texture(when, .9, low ? .04 : .018, low ? 500 : 1800);
    if (id === 'solaris') pulse(when + .2, 5, 92);
    if (id === 'void') pulse(when + .3, 3, 55);
    if (id === 'opening' || id === 'prologue' || id === 'aetherial' || id === 'reveal' || id === 'order') sparkle(when + .28, id === 'opening' || id === 'prologue' ? 8 : 11);
    if (id === 'lunar' || id === 'argent') sparkle(when + .48, 7);
    if (id === 'entry' || id === 'fragment' || id === 'custom' || id === 'cart' || id === 'armory') pulse(when + .1, 4, 220);
  }
  function stop() { for (var i = 0; i < active.length; i++) { try { active[i].stop(); } catch (e) {} } active = []; }
  function play(id) {
    stop(); var c = getContext(); if (!c) return false;
    var now = c.currentTime + .03, list = patterns[id] || patterns.opening;
    for (var i = 0; i < list.length; i++) tone(list[i][0], now + list[i][1], list[i][2], list[i][3], list[i][4], i % 2 ? -.36 : .36);
    flare(now, id); return true;
  }
  function bind() {
    applySavedEdits();
    var title = (document.title || '').toLowerCase();
    var pageCue = title.indexOf('solaris') >= 0 ? 'solaris' : title.indexOf('lunar') >= 0 ? 'lunar' : title.indexOf('argent') >= 0 ? 'argent' : title.indexOf('aetherial') >= 0 ? 'aetherial' : title.indexOf('void') >= 0 ? 'void' : title.indexOf('prologue') >= 0 || title.indexOf('origin') >= 0 ? 'prologue' : 'opening';
    if (!document.querySelector('.af-sound-dock')) {
      var dock = document.createElement('div');
      dock.className = 'af-sound-dock';
      dock.innerHTML = '<button type="button" data-audio-cue="' + pageCue + '" aria-label="Play page sound">♫ Play page sound</button>';
      document.body.appendChild(dock);
    }
    var sections = document.querySelectorAll('body > section');
    for (var s = 1; s < sections.length; s++) {
      if (!sections[s].querySelector('.af-part-sound')) {
        var part = document.createElement('button');
        part.type = 'button'; part.className = 'af-part-sound'; part.setAttribute('data-audio-cue', 'fragment'); part.textContent = '♫ Part sound';
        sections[s].appendChild(part);
      }
    }
    var nodes = document.querySelectorAll('[data-audio-cue]');
    for (var i = 0; i < nodes.length; i++) (function (node) {
      node.addEventListener('click', function (event) {
        var isLink = node.tagName && node.tagName.toLowerCase() === 'a';
        var isSubmit = node.getAttribute('type') === 'submit'; if (!isLink && !isSubmit) { event.preventDefault(); event.stopPropagation(); }
        var ok = play(node.getAttribute('data-audio-cue'));
        node.classList.add('audio-playing');
        node.setAttribute('aria-label', 'Playing ' + (node.getAttribute('aria-label') || 'sound'));
        setTimeout(function () { node.classList.remove('audio-playing'); }, 4600);
        if (!ok) alert('Audio is not supported by this browser.');
      });
    })(nodes[i]);
  }
  var style = document.createElement('style');
  style.textContent = '.af-sound-dock{position:fixed;right:18px;bottom:18px;z-index:9999}.af-sound-dock button,.af-part-sound{border:1px solid #d7a62a;background:#17120a;color:#d7a62a;padding:10px 14px;border-radius:6px;font-weight:700;cursor:pointer}.af-part-sound{position:absolute;right:18px;bottom:18px;z-index:30;font-size:11px;opacity:.9}.af-sound-dock .audio-playing,.af-part-sound.audio-playing{background:#d7a62a;color:#080808}';
  document.head.appendChild(style);
  window.AngelFireAudio = { play: play, stop: stop, bind: bind };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
